import script from "./WordInlineEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./WordInlineEditor.vue?vue&type=script&setup=true&lang=ts"

import "./WordInlineEditor.vue?vue&type=style&index=0&id=12f82dd1&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12f82dd1"]])

export default __exports__